import { render } from "./ProsesDIPA.vue?vue&type=template&id=612f7be1"
import script from "./ProsesDIPA.vue?vue&type=script&lang=js"
export * from "./ProsesDIPA.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__